import { Component, OnInit } from '@angular/core';
import { ChangeLogService } from 'src/app/services/changeLog/ChangeLog.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-change-log',
    templateUrl: './change-log.component.html',
    styleUrl: './change-log.component.css'
})
export class ChangeLogComponent implements OnInit {
        changeLogHtml: string = '';
        doneLoading: boolean = false;

        constructor(private changeLogService: ChangeLogService) {}
        async ngOnInit(): Promise<void> {
            const portalChangelog = await firstValueFrom(this.changeLogService.GetPortalChangeLog());
            const apiChangelog = await firstValueFrom(this.changeLogService.GetApiChangeLog());
            this.changeLogHtml = this.mergeChangelogs(apiChangelog, portalChangelog);
            this.doneLoading = true;
        }

        private mergeChangelogs(apiChangelog: string, portalChangelog: string): string {
            const releases = new Map<string, { api?: string, portal?: string, date?: string }>();
            
            this.extractReleases(portalChangelog, 'portal', releases);
            this.extractReleases(apiChangelog, 'api', releases);

            let result = '<div class="changelog">';
            for (const [version, content] of releases) {
                result += `
                <div class="release-card">
                    <section class="release">
                        <h2>Release ${version}</h2>
                        <h3 class="release-date">${content.date || 'Date not specified'}</h3>
                        ${this.formatContent(content.api || '', content.portal || '')}
                    </section>
                </div>
                `;
            }
            result += '</div>';
            return result;
        }

        private formatContent(apiContent: string, portalContent: string): string {
            const sections = ['Enhancements', 'Removals', 'Bug Fixes'];
            let formattedContent = `
                <table class="changelog-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>Portal Changes</th>
                        <th>API Changes</th>
                    </tr>
                </thead>
                <tbody>`;
            
            let hasContent = false;
            
            for (const section of sections) {
                const apiItems = this.extractSectionItems(apiContent, section);
                const portalItems = this.extractSectionItems(portalContent, section);
                
                if (apiItems.length > 0 || portalItems.length > 0) {
                    hasContent = true;
                    formattedContent += `
                        <tr>
                            <td class="section-type ${section.toLowerCase().replace(" ", "-")}">${section}</td>
                            <td class="section-items">
                                ${portalItems.length > 0 ? 
                                    `<ul>${portalItems.map(item => `<li>${item}</li>`).join('')}</ul>` : 
                                    '<p>No changes</p>'}
                            </td>
                            <td class="section-items">
                                ${apiItems.length > 0 ? 
                                    `<ul>${apiItems.map(item => `<li>${item}</li>`).join('')}</ul>` : 
                                    '<p>No changes</p>'}
                            </td>
                        </tr>
                    `;
                }
            }

            formattedContent += '</tbody></table>';
            return hasContent ? formattedContent : '<p>No changes</p>';
        }

        private extractSectionItems(content: string, section: string): string[] {
            const sectionRegex = new RegExp(`###\\s*${section}\\s*([\\s\\S]*?)(?=###|$)`, 'i');
            const sectionMatch = content.match(sectionRegex);
            
            if (sectionMatch) {
                return sectionMatch[1]
                    .trim()
                    .split('\n')
                    .filter(item => item.trim().startsWith('-'))
                    .map(item => item.trim().substring(1).trim());
            }
            return [];
        }

        private extractReleases(changelog: string, source: 'api' | 'portal', releases: Map<string, { api?: string, portal?: string, date?: string }>) {
            const releaseRegex = /##\s*Release\s+(\d+\.\d+\.\d+)\s*\n+####\s*Release date:\s*([^\n]+)\s*([\s\S]*?)(?=##\s*Release|$)/g;
            let match;

            while ((match = releaseRegex.exec(changelog)) !== null) {
                const version = match[1].trim();
                const date = match[2].trim();
                const content = match[3].trim();
                
                if (!releases.has(version)) {
                    releases.set(version, { date });
                }
                const entry = releases.get(version)!;
                if (source === 'api') {
                    entry.api = content;
                } else {
                    entry.portal = content;
                }
            }
        }
}
